import React from 'react';
import { Quote } from 'lucide-react';
import { useI18n } from '@/lib/i18n';

export const TestimonialCard = ({ testimonial, testId }) => {
  const { t } = useI18n();

  return (
    <figure
      data-testid={testId}
      className="flex h-full flex-col justify-between rounded-[16px] border border-[color:var(--rmh-border)] p-7 sm:p-8"
      style={{
        backgroundColor: 'var(--rmh-surface)',
        boxShadow: 'var(--shadow-hairline)',
      }}
    >
      <div>
        <Quote
          className="h-6 w-6"
          strokeWidth={1.2}
          style={{ color: 'var(--rmh-accent)' }}
          aria-hidden="true"
        />
        <blockquote className="mt-5 font-serif text-[1.02rem] leading-[1.55] text-[color:var(--rmh-ink)] sm:text-[1.1rem]">
          &ldquo;{testimonial.quote}&rdquo;
        </blockquote>
      </div>
      <figcaption className="mt-7">
        <div className="rmh-rule" />
        <div className="mt-4 flex items-baseline justify-between gap-3">
          <div>
            <p className="text-[0.86rem] font-medium text-[color:var(--rmh-ink)]">
              {testimonial.name}
            </p>
            <p className="mt-1 text-[0.76rem] text-[color:var(--rmh-muted)]">
              {testimonial.role}
            </p>
          </div>
          {testimonial.placeholder ? (
            <span className="rmh-eyebrow shrink-0 text-[0.55rem]">
              {t.common.placeholder}
            </span>
          ) : null}
        </div>
      </figcaption>
    </figure>
  );
};

export default TestimonialCard;
